import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/event/modi/modi-logo.png'
import _imports_1 from '@/assets/img/event/modi/onlylive-logo.png'
import _imports_2 from '@/assets/img/event/modi/modi-top-finished-img.png'
import _imports_3 from '@/assets/img/event/modi/modi-schedule.png'
import _imports_4 from '@/assets/img/event/modi/modi-main-top.png'
import _imports_5 from '@/assets/img/event/modi/modi-photograph.jpg'
import _imports_6 from '@/assets/img/event/modi/ranking-benefits.png'
import _imports_7 from '@/assets/img/event/modi/rank-top-img.png'
import _imports_8 from '@/assets/img/event/modi/benefit01.png'
import _imports_9 from '@/assets/img/event/modi/benefit02.png'
import _imports_10 from '@/assets/img/event/modi/benefit03.png'
import _imports_11 from '@/assets/img/event/modi/rank-sec-thi.png'
import _imports_12 from '@/assets/img/event/modi/notes-img.png'
import _imports_13 from '../../../../assets/img/event/modi/epos-banner.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-fe4f36b4")

_pushScopeId("data-v-fe4f36b4")
const _hoisted_1 = { class: "modi-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lp-header" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "modi-img",
    src: _imports_0
  }),
  /*#__PURE__*/_createVNode("img", {
    class: "onlylive-img",
    src: _imports_1
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "modi-top-img" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "modi-image",
    src: _imports_2
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "event-period" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "period-img",
    src: _imports_3
  })
], -1)
const _hoisted_5 = { class: "modi-main" }
const _hoisted_6 = { class: "modi-main-top-container" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "modi-main-top" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "modi-main-content",
    src: _imports_4
  }),
  /*#__PURE__*/_createVNode("p", { class: "modi-main-content-bottom" }, [
    /*#__PURE__*/_createTextVNode("配信時間・人数などに応じて決定されるランキングで"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("1位〜3位の方は、2021年12月10日〜20日に"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("onlyliveの広告タレントとして"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("「渋谷モディビジョン広告」に掲載されるなどの特典が✨")
  ])
], -1)
const _hoisted_8 = { class: "left-bg-img" }
const _hoisted_9 = { class: "modi-photograph" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "under-circle" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "photograph-circle-img",
    src: _imports_5
  })
], -1)
const _hoisted_11 = {
  class: "photograph-btn",
  href: "#benefits"
}
const _hoisted_12 = { class: "btn-content" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("特典をチェック")
const _hoisted_14 = {
  class: "benefits-bg",
  id: "benefits"
}
const _hoisted_15 = { class: "benefits-section" }
const _hoisted_16 = { class: "benefits-top" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "benefits-top-img" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "benefits-img",
    src: _imports_6
  })
], -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_7 })
], -1)
const _hoisted_19 = { class: "benefits-content" }
const _hoisted_20 = { key: "{}" }
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("p", { class: "published-schedule" }, "（掲載・掲出期間 12月10日〜20日）", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "rectangle-list" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rectangle",
    src: _imports_8
  }),
  /*#__PURE__*/_createVNode("img", {
    class: "rectangle rec-second",
    src: _imports_9
  }),
  /*#__PURE__*/_createVNode("img", {
    class: "rectangle",
    src: _imports_10
  })
], -1)
const _hoisted_25 = { class: "benefits-bottom" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "rank-sec-thi" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_11 })
], -1)
const _hoisted_27 = { class: "benefits-content" }
const _hoisted_28 = { key: "list" }
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("p", { class: "published-schedule" }, "（掲載・掲出期間 12月10日〜20日）", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "entry-benefits-section" }, [
  /*#__PURE__*/_createVNode("div", { class: "rectangle-list rectangle-list-sec" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "rectangle rec-four",
      src: _imports_8
    }),
    /*#__PURE__*/_createVNode("img", {
      class: "rectangle rec-five",
      src: _imports_9
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "entry-bg-bottom" }, [
    /*#__PURE__*/_createVNode("div", { class: "entry-benefits-content" }, [
      /*#__PURE__*/_createVNode("p", { class: "entry-benefits-title" }, "エントリー特典"),
      /*#__PURE__*/_createVNode("p", { class: "entry-benefits-text" }, [
        /*#__PURE__*/_createTextVNode("12月10日〜20日に"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createTextVNode(" 渋谷モディ7F・onlyliveイベントブースにて、"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createTextVNode(" プロフィール写真の掲出")
      ])
    ])
  ])
], -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "notes-section" }, [
  /*#__PURE__*/_createVNode("div", { class: "notes-section-container" }, [
    /*#__PURE__*/_createVNode("div", { class: "notes-top-title" }, [
      /*#__PURE__*/_createVNode("img", { src: _imports_12 })
    ]),
    /*#__PURE__*/_createVNode("ul", { class: "notes-contents" }, [
      /*#__PURE__*/_createVNode("li", null, "・2021年10月1日0時00分以降通話開始分から、2021年10月31日23時59分59秒通話開始分までがランキングに加算されます。2021年10月31日23時59分59秒に通話が開始された場合、終了するまでがランキングに加算されます。")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "epos-banner" }, [
      /*#__PURE__*/_createVNode("a", {
        href: "https://www.eposcard.co.jp/gecard/portal/index.html?int_id=otop_ge_ptl",
        target: "blank"
      }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_13 })
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "modi-footer" }, [
    /*#__PURE__*/_createVNode("p", null, "© 2021 ILEO,inc.")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("a", _hoisted_11, [
              _createVNode("p", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_font_awesome_icon, {
                  class: "chevron-icon",
                  icon: "chevron-down"
                })
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _hoisted_17,
            _hoisted_18,
            _createVNode("ul", _hoisted_19, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.Tops, (top) => {
                return (_openBlock(), _createBlock("li", _hoisted_20, [
                  _createTextVNode(_toDisplayString(top), 1),
                  _hoisted_21,
                  _hoisted_22
                ]))
              }), 128))
            ]),
            _hoisted_23
          ]),
          _hoisted_24,
          _createVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode("ul", _hoisted_27, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.SecThirds, (list) => {
                return (_openBlock(), _createBlock("li", _hoisted_28, [
                  _createTextVNode(_toDisplayString(list), 1),
                  _hoisted_29,
                  _hoisted_30
                ]))
              }), 128))
            ]),
            _hoisted_31
          ]),
          _hoisted_32
        ])
      ]),
      _hoisted_33
    ])
  ]))
})